const liczbaMiejsc = { t: 'Liczba miejsc', name: 'liczba-miejsc', type: 'number' }
export default liczbaMiejsc